export default function Technologies() {
  const techCategories = [
    {
      title: "Frontend",
      items: ["React", "Angular", "Vue.js", "Next.js", "Tailwind CSS", "Bootstrap"],
    },
    {
      title: "Backend",
      items: ["Node.js", "Python", "Java", ".NET", "PHP", "Laravel"],
    },
    {
      title: "Mobile",
      items: ["Flutter", "React Native", "Swift", "Kotlin", "Firebase", "Expo"],
    },
    {
      title: "Database",
      items: ["MySQL", "PostgreSQL", "MongoDB", "Redis", "Firebase", "DynamoDB"],
    },
    {
      title: "Cloud & DevOps",
      items: ["AWS", "Azure", "GCP", "Docker", "Kubernetes", "Jenkins"],
    },
    {
      title: "Design & Marketing",
      items: ["Figma", "Adobe Suite", "Google Analytics", "SEMrush", "Mailchimp", "HubSpot"],
    },
  ];

  return (
    <section id="technologies" className="technologies" style={{ padding: "60px 0", background: "#f8f9fa" }}>
      <div className="container">
        <header className="section-header">
          <h2>Technologies We Work With</h2>
          <p>We stay current with the latest tools and platforms to deliver future-ready solutions</p>
        </header>
        <div className="row gy-4">
          {techCategories.map((category, index) => (
            <div className="col-lg-4 col-md-6" key={index} data-aos="fade-up" data-aos-delay={100 + index * 100}>
              <div style={{ background: "#fff", padding: "25px", borderRadius: "10px", boxShadow: "0 2px 15px rgba(0,0,0,0.05)", height: "100%" }}>
                <h4 style={{ color: "#0070f3", marginBottom: "15px" }}>{category.title}</h4>
                <div className="d-flex flex-wrap gap-2">
                  {category.items.map((item, i) => (
                    <span
                      key={i}
                      className="badge"
                      style={{ background: "#e8f4fd", color: "#333", padding: "8px 16px", borderRadius: "20px", fontSize: "13px", fontWeight: "500" }}
                    >
                      {item}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}